import { getMessages } from '../../../../../../../store/constants';
import { ECustomPropertyType } from '../../../../../../../store/customProperties/types';

export const CUSTOM_PROPERTY_TYPES = [
    {
        icon: 'text',
        name: getMessages().getText('card_form_custom_section_type_text'),
        value: ECustomPropertyType.TEXT,
    },
    {
        localIcon: 'dropdown',
        name: getMessages().getText('card_form_custom_section_type_dropdown'),
        value: ECustomPropertyType.SELECT,
    },
    {
        localIcon: 'number',
        name: getMessages().getText('card_form_custom_section_type_number'),
        value: ECustomPropertyType.NUMBER,
    },
    {
        icon: 'calendar',
        name: getMessages().getText('card_form_custom_section_type_date'),
        value: ECustomPropertyType.DATE,
    },
    {
        icon: 'mail',
        name: getMessages().getText('card_form_custom_section_type_email'),
        value: ECustomPropertyType.EMAIL,
    },
    {
        localIcon: 'phone',
        name: getMessages().getText('card_form_custom_section_type_phone'),
        value: ECustomPropertyType.PHONE,
    },
];
